module.exports = __webpack_public_path__ + "img/account-img1.92985d78.png";